<template>
    <div>
        <van-popup v-model="show" position="bottom">
            <van-picker
                title="选择银行"
                show-toolbar
                :columns="columns"
                @confirm="confirmBankBoxFun"
                @cancel="showPopup(false)"
            />
        </van-popup>
    </div>
</template>

<script>
import Vue from 'vue';
import { Popup } from 'vant';
import { Picker } from 'vant';
Vue.use(Popup);
Vue.use(Picker);
var that;
export default {
    props:['columns'],
    data() {
        return {
            show: false,
        };
    },
    mounted(){
        that = this;
    },
    methods: {
        showPopup(val) {
            that.show = val;
        },
        // 时间弹框 点击确认
        confirmBankBoxFun(val){
            that.show = false;
            that.$emit('bankConfirm',val)
        }

    },
}
</script>

<style scoped>

</style>